import { useMutation, useQuery } from 'react-query'
import ApiService from './ApiService'
import appConfig from '../configs/app.config'

export const apiFetchSecurityGroups = (options = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useQuery(
    'securityGroups',
    async () => {
      const response = await ApiService.fetchData({
        url: `${appConfig.apiRoot}/Security/securityGroups`,
        method: 'get'
      })
      const data = response.data
      return {
        records: data.records || data.result,
        total: data.total || data.totalRecords || data.totalrecords || 0
      }
    },
    options
  )
}

export const apiFetchSecurityGroupUsers = (securityGroup, options = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useQuery(
    ['securityGroupUser', securityGroup],
    async () => {
      const response = await ApiService.fetchData({
        url: `${appConfig.apiRoot}/Security/securitygroupUser`,
        method: 'get',
        params: { securityGroup }
      })
      const data = JSON.parse(response.data)
      return data
    },
    options
  )
}

export const apiFetchSecurityUserGroups = (userID, options = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useQuery(
    ['securityGroupUser', userID],
    async () => {
      const response = await ApiService.fetchData({
        url: `${appConfig.apiRoot}/Security/securityUserGroup`,
        method: 'get',
        params: { userID }
      })
      const data = JSON.parse(response.data)
      return data
    },
    options
  )
}


export const apiStoreSecurityGroup = (options = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMutation(async ({ groupId, groupName, groupDescription, active, assignUsers }) => {
    const params = { groupName, groupDescription, active }
    if (groupId) params.groupId = groupId
    const response = await ApiService.fetchData({
      url: groupId ? `${appConfig.apiRoot}/security/editSecurityGroup` : `${appConfig.apiRoot}/security/addsecuritygroup`,
      method: 'post',
      params,
      data: (assignUsers || []).map(user => ({
        userID: user.value
      }))
    })
    return response.data
  }, options)
}

export const apiDeleteSecurityGroup = (options = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMutation(async (securityGroup) => {
    const response = await ApiService.fetchData({
      url: `${appConfig.apiRoot}/security/deleteSecurityGroup`,
      method: 'post',
      params: { securityGroup }
    })
    return response.data
  }, options)
}

export const apiGetUser = (userId, options = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useQuery(
    ['staff', userId],
    async () => {
      const response = await ApiService.fetchData({
        url: `${appConfig.apiRoot}/Security/getUserDetail`,
        method: 'get',
        params: {
          user: userId,
          userId: userId
        }
      })

      const user = response.data?.records?.[0] || null;
      if(user) {
        const responseSG = await ApiService.fetchData({
          url: `${appConfig.apiRoot}/Security/securityUserGroup`,
          method: 'get',
          params: { userID: user.userId }
        })
        if(responseSG) {
          user.groups = JSON.parse(responseSG.data)
        }
      }
      return user;

    },
    { ...options, cacheTime: 0 }
  )
}

export function apiSaveUser(options = {}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMutation(async ({ groupIds, ...params }) => {
    const response = await ApiService.fetchData({
      url: `${appConfig.apiRoot}/Security/${params.userId ? 'editUser' : 'addUser'}`,
      method: 'post',
      params,
      data: (groupIds || []).map(group => ({
        groupID: group
      }))
    })
    return response.data
  }, options)
}

export function apiAssignShelfAccessToGroup(options = {}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMutation(async ({ assignGroups, lift, liftType, shelf, warehouseId, zoneId }) => {
    const response = await ApiService.fetchData({
      url: `${appConfig.apiRoot}/Security/assignShelfAccessToGroup`,
      method: 'post',
      params: {
        lift, liftType, shelf, warehouseId, zoneId
      },
      data: (assignGroups || []).map(group => ({
        groupID: group
      }))
    })
    return response.data
  }, options)
}

export function apiResetUserPassword(options = {}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useMutation(async ({ userId, oldPassword, newPassword }) => {
    const response = await ApiService.fetchData({
      url: `${appConfig.apiRoot}/Security/resetUserPassword`,
      method: 'post',
      params: {
        userId, oldPassword, newPassword
      }
    })
    return response.data
  }, options)
}


export const apiGetSystemConfiguration = ({ licenseKey }) => ApiService.fetchData({
  url: `${appConfig.apiRoot}/Security/systemConfiguration`,
  method: 'get',
  params: {
    licenseKey
  }
})